var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isNoopVal)?_c('div',[_vm._v("--")]):_c('div',[_c('image-item',{staticClass:"image",attrs:{"src":_vm.value[0],"alt":"img"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }